<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 180.13 180.47" style="enable-background:new 0 0 180.13 180.47;" xml:space="preserve">
    <circle class="st0" cx="89.72" cy="90.16" r="81.7"/>
    <polyline class="st0" points="89.72,52.98 89.72,90.16 124.65,125.09 "/>
    </svg>

</template>

<script>
export default {
    
}
</script>

<style lang="scss" scoped>
    .st0{fill:none;stroke:#000000;stroke-width:10;stroke-miterlimit:10;}
</style>